var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center auth_title mb-10"},[_vm._v(" "+_vm._s(_vm.$tr("auth", "key_18"))+" ")]),_c('div',{staticClass:"d-flex justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"smoke","width":"2"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }